import DebiaProcess from 'app/components/OrderPayment/Debia/DebiaProcess';
import React from 'react';

const DebiaPayment = () => {
  return <DebiaProcess />;
};

export default DebiaPayment;
